let common = {
    Moment : require('moment'),
    Init: ()=> {

        Jd.off('click', '.main-content-category-params-btn').on('click', '.main-content-category-params-btn', function(){
            if (J('.main-content-category-params-container').is(':visible')) {
                J('.main-content-category-params-container').hide();
            } else {
                J('.main-content-category-params-container').show();
            }
        });


        Jd.off('click', '.flash-message-close').on('click', '.flash-message-close', function(){
            J(this).parent('.flash-message').remove();
        });

        if (J('#header_datetime').length) {

            setInterval(function(){
                J('#header_datetime').text( common.Moment().locale("fr").format('LLLL') );
            },1000);
        }

        if (J('#instalment_selector').length) {

            Jd.off('change', '#instalment_selector').on('change', '#instalment_selector', function(){
                let value = J(this).val();
                J('.instalment-list-item').hide();
                if (J('.instalment-list-item[data-echeance="'+value+'"]').length) {
                    J('.instalment-list-item[data-echeance="'+value+'"]').fadeIn(200);
                }
            });

            let payment_in_instalments_selector_value = J('#instalment_selector').find('option[selected="selected"]').attr('value');
            J('#instalment_selector').val( payment_in_instalments_selector_value ).trigger('change');
        }

        J(window).scroll(function() {
            var scrollTop = J(window).scrollTop();
            if (scrollTop >= 100 && J('.app-scroll-to-top-container').hasClass('app-scroll-to-top-container-hidden')) {
                J('.app-scroll-to-top-container').removeClass('app-scroll-to-top-container-hidden')
            }
            if (scrollTop < 100 && !J('.app-scroll-to-top-container').hasClass('app-scroll-to-top-container-hidden')) {
                J('.app-scroll-to-top-container').addClass('app-scroll-to-top-container-hidden')
            }
        });

        Jd.off('click', '.app-scroll-to-top-container').on('click', '.app-scroll-to-top-container', function(){
            J('html').animate({scrollTop: 0}, "slow");
        });
    }
}
module.exports = common;